import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

const CarePlanIcon: React.FC<IconProps> = (props) => (

<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" {...props} xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3701_5649)">
<path d="M6.125 15.5C5.60563 15.5 5.1875 15.0819 5.1875 14.5625V10.8125H1.4375C0.918125 10.8125 0.5 10.3944 0.5 9.875V6.125C0.5 5.60563 0.918125 5.1875 1.4375 5.1875H5.1875V1.4375C5.1875 0.918125 5.60563 0.5 6.125 0.5H9.875C10.3944 0.5 10.8125 0.918125 10.8125 1.4375V5.1875H14.5625C15.0819 5.1875 15.5 5.60563 15.5 6.125V9.875C15.5 10.3944 15.0819 10.8125 14.5625 10.8125H10.8125V14.5625C10.8125 15.0819 10.3944 15.5 9.875 15.5H6.125ZM6.125 11.2812H9.875L8 9.40625L6.125 11.2812ZM6.125 8.9375H9.875L8 7.0625L6.125 8.9375ZM6.125 6.59375H9.875L8 4.71875L6.125 6.59375Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_3701_5649">
<rect width="16" height="16" fill="currentColor"/>
</clipPath>
</defs>
</svg>


);

export default CarePlanIcon;
